<div class="stat_infos_header">
    <div class="select_camera_and_days">
      <form class="camera_select" [formGroup]="choiceDateForm" (ngSubmit)="onSubmit(false)">
        <div class="input_form">
          <mat-form-field appearance="outline" [color]="color">
            <mat-label>Selection de la caméra</mat-label>
            <mat-select disableRipple formControlName="cameraId" (valueChange)="onSubmit(true)">
              <mat-option [value]="c.name" *ngFor="let c of camera">{{c.name}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Du</mat-label>
            <input matInput [max]="choiceDateForm.get('to').value" [matDatepicker]="from" formControlName="from">
            <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
            <mat-datepicker #from></mat-datepicker>
          </mat-form-field>
          <span>-</span>
          <mat-form-field appearance="outline">
            <mat-label>Au</mat-label>
            <input matInput [max]="today" [matDatepicker]="to" formControlName="to" >
            <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
            <mat-datepicker #to></mat-datepicker>
          </mat-form-field>
        </div>
        <button type="submit"  [disabled]="choiceDateForm.invalid">
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>
        <fa-icon [icon]="faFileExcel" class="faFileExcel" (click)="exportexcel()" ></fa-icon>
  
      </form>
      
    </div>
  </div>
  
  <mat-spinner [diameter]="50" *ngIf="!loading"></mat-spinner>
  <div class="charts" *ngIf="loading" >
    <div class="chart_header">
      <div class="tags">
        <div [ngClass]="{tag_active: tag === 'week', tag_deactive: tag !== 'week' }" (click)="setTag('week'); setDateFrom()">Semaine</div>
        <div [ngClass]="{tag_active: tag === 'day/hour', tag_deactive: tag !== 'day/hour' }" (click)="setTag('day/hour')">Jour/heure</div>
      </div>
      <div class="days_select" *ngIf="tag === 'day/hour'"  >
        <mat-checkbox *ngFor="let d of daysSelected" [id]='d + "-cb"' [class]="d" [color]="color" [checked]="true"
          (change)="selectedOrNot(d)"> {{d}}
        </mat-checkbox>
      </div>
    </div>

    <div *ngIf="tag === 'week'" class="divChart">
        
        <h4 *ngIf="dateDiff > 0">{{datas?.label}} <br> du {{f.from.value | date: 'shortDate'}} au {{f.to.value  | date: 'shortDate'}}</h4>
        <h4 *ngIf="dateDiff < 1">{{datas?.label}} <br> du {{f.from.value | date: 'shortDate'}} </h4>
        <div class="chart">
          <canvas  baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
            [legend]="barChartLegend" [chartType]="barChartType" label="nbr de voitures"> </canvas>
            <div class="label_orderly">nbr de véhicule</div>
        </div>

    </div>

    <div class="charts_day_hour"  *ngIf="tag === 'day/hour'" >
      <app-chart *ngFor="let d of datasDayHour,let i = index" [day]="d?.label" [id]="d?.label" [data]="d?.data"
      [camera]="choiceDateForm.get('camera')?.value || camera[0].name" [dateStart]="choiceDateForm.get('from')?.value"  [dateEnd]="choiceDateForm.get('to')?.value" [dateLabel]="sendDateTo(i)"  [labelOrderly]="'nbr de véhicule'" [typeChart]="'carSuction'" [@show]></app-chart>
    </div>
  </div>
  